export const WORK_ORDER_DISCLAIMER_ID = 'automotive-work-order-disclaimer';
